// src/components/store/sections/hero-banner/HeroV67CircularportalCoralFlame.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV67CircularportalCoralFlame(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={67}
      archKey="circular_portal"
      archLabel="Circular Portal Hero"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      {...props}
    />
  );
}
